//src/services/adminHomepage.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminCategoryCards = () =>
  adminApiRequest("/homepage/admin/category-cards");

export const createAdminCategoryCard = (data) =>
  adminApiRequest("/homepage/admin/category-cards", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateAdminCategoryCard = (id, data) =>
  adminApiRequest(`/homepage/admin/category-cards/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const deleteAdminCategoryCard = (id) =>
  adminApiRequest(`/homepage/admin/category-cards/${id}`, {
    method: "DELETE",
  });
  

export const getAdminCategoryCarousel = () =>
  adminApiRequest("/homepage/admin/category-carousel");

export const updateAdminCategoryCarouselImage = (id, data) =>
  adminApiRequest(`/homepage/admin/category-carousel/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const updateAdminCategoryCarouselOrder = (id, sort_order) =>
  adminApiRequest(`/homepage/admin/category-carousel/${id}/order`, {
    method: "PUT",
    body: JSON.stringify({ sort_order }),
  });


export const uploadAdminImage = async (file) => {
  const form = new FormData();
  form.append("image", file);

  const BASE =
    process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL.replace(/\/api$/, "")
      : "http://localhost:5005";

  const token = localStorage.getItem("adminToken");

  const res = await fetch(`${BASE}/api/homepage/admin/upload-image`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: form,
  });

  if (!res.ok) {
    throw new Error("Image upload failed");
  }

  return res.json(); // { url: "/images/xxx.jpg" }
};

  export const getAdminCategoryCarouselSection = () =>
  adminApiRequest("/homepage/admin/category-carousel-section");

export const updateAdminCategoryCarouselSection = (data) =>
  adminApiRequest("/homepage/admin/category-carousel-section", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const getAdminAboutPageSettings = () =>
  adminApiRequest("/homepage/admin/about-page");

export const updateAdminAboutPageSettings = (data) =>
  adminApiRequest("/homepage/admin/about-page", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const getAdminTermsConditionsSettings = () =>
  adminApiRequest("/homepage/admin/terms-conditions");

export const updateAdminTermsConditionsSettings = (data) =>
  adminApiRequest("/homepage/admin/terms-conditions", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const getAdminPrivacyPolicySettings = () =>
  adminApiRequest("/homepage/admin/privacy-policy-settings");

export const updateAdminPrivacyPolicySettings = (data) =>
  adminApiRequest("/homepage/admin/privacy-policy-settings", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const getAdminPaymentDeliverySettings = () =>
  adminApiRequest("/homepage/admin/payment-delivery-settings");

export const updateAdminPaymentDeliverySettings = (data) =>
  adminApiRequest("/homepage/admin/payment-delivery-settings", {
    method: "PUT",
    body: JSON.stringify(data),
  });

export const getAdminReturnsPageSettings = () =>
  adminApiRequest("/homepage/admin/returns-page-settings");

export const updateAdminReturnsPageSettings = (data) =>
  adminApiRequest("/homepage/admin/returns-page-settings", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const getAdminSearchOverlaySettings = () =>
  adminApiRequest("/homepage/admin/search-overlay");

export const updateAdminSearchOverlaySettings = (data) =>
  adminApiRequest("/homepage/admin/search-overlay", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const getAdminProductsPageFeaturedSection = () =>
  adminApiRequest("/homepage/admin/products-page-featured");

export const updateAdminProductsPageFeaturedSection = (data) =>
  adminApiRequest("/homepage/admin/products-page-featured", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const getAdminProductInstagramReelsSection = () =>
  adminApiRequest("/homepage/admin/product-instagram-reels");

export const updateAdminProductInstagramReelsSection = (data) =>
  adminApiRequest("/homepage/admin/product-instagram-reels", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const getAdminProductLookSection = () =>
  adminApiRequest("/homepage/admin/product-look-section");

export const updateAdminProductLookSection = (data) =>
  adminApiRequest("/homepage/admin/product-look-section", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const getAdminHeaderOverlayImages = () =>
  adminApiRequest("/homepage/admin/header-overlay-images");

export const updateAdminHeaderOverlayImages = (data) =>
  adminApiRequest("/homepage/admin/header-overlay-images", {
    method: "PUT",
    body: JSON.stringify(data),
  });

  export const getAdminHomepageCategoryProductRows = () =>
  adminApiRequest("/homepage/admin/category-product-rows");

export const updateAdminHomepageCategoryProductRows = (data) =>
  adminApiRequest("/homepage/admin/category-product-rows", {
    method: "PUT",
    body: JSON.stringify(data),
  });